import { sdk } from '@/services/sdk';
import { fillTemplate, nameOf, rows } from '@/shared/data';
import { TEMPLATE_FIELDS } from '@/shared/fields';
import { money, orderTotal, paymentLabel, planSummary } from '@/shared/pricing';
import { formatLocalDate, DATE_FORMATS } from '@/utils/date';

const { eq } = window.ApperSDK.CoreSDK;

/** Placeholder values for a template, taken from an order. `extra` overrides any of them. */
export function orderVars(order, extra = {}) {
  return {
    name: order?.full_name_c || nameOf(order?.customer_c) || 'there',
    code: order?.Name ?? '',
    server: order?.line_server_c ?? '',
    username: order?.line_username_c ?? '',
    password: order?.line_password_c ?? '',
    plan: planSummary(order),
    amount: money(orderTotal(order)),
    method: paymentLabel(order?.payment_method_c),
    ends: order?.ends_at_c ? formatLocalDate(order.ends_at_c, DATE_FORMATS.LONG) : 'never',
    discount: '',
    ...extra,
  };
}

export function renderTemplate(template, vars) {
  return {
    subject: fillTemplate(template?.subject_c ?? '', vars),
    body: fillTemplate(template?.body_c ?? '', vars),
  };
}

/** Templates of one kind, newest edit first. */
export function templatesOf(kind) {
  return sdk
    .table('templates_c')
    .select(TEMPLATE_FIELDS)
    .where(eq('kind_c', kind))
    .orderBy('Name')
    .limit(20)
    .fetch()
    .then(rows);
}
